import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ContentHeaderBreadcrumb } from './content-header-breadcrumb';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-content-header',
  imports: [MatIcon],
  templateUrl: './content-header.component.html',
  standalone: true,
  styleUrl: './content-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentHeaderComponent {
  breadcrumbs = input<ContentHeaderBreadcrumb[]>();

  private location = inject(Location);
  private router = inject(Router);

  breadcrumbClicked(breadcrumb: ContentHeaderBreadcrumb) {
    if (breadcrumb.navigateBack) {
      this.location.back();
    }

    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]).then();
    }
  }
}
